(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-photos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.__cgReady) return;
      root.__cgReady = true;
      var track = root.querySelector('[data-cg-track]');
      var prev = root.querySelector('[data-cg-prev]');
      var next = root.querySelector('[data-cg-next]');
      if (!track) return;

      function step() {
        var slide = track.querySelector('.cg__slide');
        if (!slide) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return slide.getBoundingClientRect().width + gap;
      }

      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
        root.classList.toggle('cg--static', max <= 0);
      }

      if (prev) {
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -step(), behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({ left: step(), behavior: 'smooth' });
        });
      }
      track.addEventListener(
        'scroll',
        function () {
          window.requestAnimationFrame(update);
        },
        { passive: true }
      );
      window.addEventListener('resize', update);
      update();
    }

    function boot() {
      var roots = document.querySelectorAll('[data-cg]');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-guide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('[data-gg-scroll]');
      if (!link) return;
      var target = document.querySelector('[data-bundle-offer]') || document.querySelector('product-form-component');
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
